<template>
  <div class="cancel-confirm-page">
    <sub-header-section :pageTitle="$tc('CancelPage.sectionTitle')" />

    <cancel-confirm-pane />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import CancelConfirmPane from '@/components/pc/MyPage/CancelPage/CancelConfirmPane.vue'
/**
 * 退会確認ページ
 */
export default defineComponent({
  name: 'CancelConfirmPage',
  components: {
    SubHeaderSection,
    CancelConfirmPane,
  },
})
</script>

<style lang="scss" scoped>
.cancel-confirm-page {
  &__header {
    position: sticky;
    top: 0;
  }
}
</style>
